module.exports = __webpack_public_path__ + "static/media/cys.52ef2259.gif";